import { UserManager } from 'oidc-client'
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux'
import { sessionTerminated, userFound } from 'redux-oidc'

import { types } from '@cinch/oxd-redux/auth/src'
import { StorageKeys, update } from '@cinch/oxd-utils/storage/src'
import { reset } from '@cinch/oxd-utils/analytics/src/segment/api-calls'

type MiddlewareHandler = (store: MiddlewareAPI, next: Dispatch<AnyAction>, action: any, userManager: UserManager) => any

export const middlewareHandler: MiddlewareHandler = (store, next, action, userManager) => {
  if (action.type === types.LOGIN) {
    const state = store.getState()

    if (typeof window !== 'undefined' && !!state.profile && !!state.profile.signupFavouriteVehicleId) {
      update(StorageKeys.favouriteVehicle, {
        id: state.profile.signupFavouriteVehicleId,
        url: `${window.location.pathname}${window.location.search}`,
      })
    }

    if (typeof window !== 'undefined' && !!state.profile && !!state.profile.signupDirectFavouriteVehicleId) {
      update(StorageKeys.directFavouriteVehicle, {
        id: state.profile.signupDirectFavouriteVehicleId,
        url: `${window.location.pathname}${window.location.search}`,
      })
    }

    return userManager.signinRedirect().then(next(action))
  }

  if (action.type === types.LOGOUT) {
    reset()
    return userManager.signoutRedirect().then(next(action))
  }

  if (action.type === types.NAVIGATE_TO_NEW_ROUTE || action.type === types.UPDATE_AUTH) {
    const { oidc } = store.getState()
    const userInState = !!oidc.user
    const userNotInState = oidc.user === null

    userManager
      .getUser()
      .then((user) => {
        const userInStorage = !!user && !user.expired
        const userNotInStorage = user === null

        // Ensure user in oidc state is always in sync with user in localStorage.
        userInStorage && userNotInState && store.dispatch(userFound(user))
        userNotInStorage && userInState && store.dispatch(sessionTerminated())
      })
      .catch()
  }

  return next(action)
}

type CreateUserMiddleware = (
  userManager: UserManager,
) => (store: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: any) => void

const createUserMiddleware: CreateUserMiddleware = (userManager) => {
  if (!userManager || !userManager.getUser) {
    throw new Error('You must provide a user manager!')
  }

  // the middleware
  return (store) => (next) => (action) => {
    middlewareHandler(store, next, action, userManager)
  }
}
// the middleware creator function
export default createUserMiddleware
